import React, { PureComponent } from 'react';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import ButtonsGroup from 'components/ui/buttonsGroup';
import Button from 'components/ui/button';
import { AnyObject } from 'types/Common';
import filtersKeys from 'constants/filters';
import { DEFAULT_BALANCE_TYPES } from '../../../constants';
import './onlineFilters.scss';
import modes from 'components/ui/buttonsGroup/modes';
import { generateRealTimeBalanceExcel, BalanceData, BalanceTotals } from 'pages/finance/online/generateOnlineExcel';
import { connect } from 'react-redux';

interface ConnectedProps {
  balanceRealTime: {
    items: BalanceData[],
    totals: BalanceTotals[]
  },
  isDownloadRealTimeBalancesEnabled: boolean
}

interface Props extends IntlProps, ConnectedProps {
  filters: AnyObject;
  balanceType: AnyObject;
  balanceCompany: AnyObject;
  isLoading: boolean;
  hasSelectedFilters: boolean;
  onChangeFilter: (data: { key: string; value: any }) => void;
  onResetFilter: () => void;
}

interface State {
  filter: AnyObject;
}

class OnlineFilters extends PureComponent<Props, State> {
  render() {
    return (
      <div className='online-filters'>
        {this.renderBalanceType()}
        {this.renderTopPanelTools()}
      </div>
    );
  }

  onDownloadExcel = () => {
    const { balanceRealTime: { items, totals } } = this.props;
    generateRealTimeBalanceExcel(items, totals);
  };

  renderBalanceType = () => {
    const { filters, balanceType, onChangeFilter } = this.props;
    const balanceTypeList = DEFAULT_BALANCE_TYPES;

    return (
      <div className='online-filters__item'>
        <div className='quick-filters__block-content'>
          <ButtonsGroup
            activeButtons={filters[filtersKeys.balanceRealTimeBalanceType]}
            mode={modes.multi}
            isLoading={balanceType?.isLoading}
            disabled={!balanceType?.isFetched || balanceType?.error}
            onClick={(values) =>
              onChangeFilter({
                key: filtersKeys.balanceRealTimeBalanceType,
                value: values,
              })
            }>
            {balanceTypeList?.map((item) => (
              <Button
                key={item.id}
                status='outline'
                id={item.id}
                text={item.text}
              />
            ))}
          </ButtonsGroup>
        </div>
      </div>
    );
  };

  renderTopPanelTools() {
    const { isLoading, hasSelectedFilters,  isDownloadRealTimeBalancesEnabled } = this.props;

    return (
      <div className='top-panel__item online-filters__item'>
        <Button
          status='danger-light'
          icon='im-Reset-filter'
          disabled={isLoading || !hasSelectedFilters}
          onClick={this.onResetFilter}
          customClass='ui-button_no-border'
        />
        {isDownloadRealTimeBalancesEnabled && <Button
          status='light'
          icon='im-Download1'
          customClass='ui-button_no-border'
          onClick={this.onDownloadExcel}
        />}
      </div>
    );
  }

  onChangeSelect(data: {
    key: string;
    itemsResult: Array<any>;
    isSingleMode?: boolean;
    isLocal?: boolean;
  }): void {
    const { key, itemsResult, isSingleMode, isLocal } = data;
    const { onChangeFilter } = this.props;
    const values = itemsResult
      .filter((item) => item.isSelected)
      .map((item) => item.id);
    const value = isSingleMode ? values[0] : values;

    if (isLocal) {
      const { filter } = this.state;

      this.setState({
        filter: {
          ...filter,
          [key]: value,
        },
      });
    } else {
      onChangeFilter({
        key,
        value,
      });
    }
  }

  onApplySelect = (data: { key: string; values: any }): void => {
    const { key, values } = data;
    const { onChangeFilter } = this.props;

    const value = values.map((item) => item.id);

    onChangeFilter({
      key,
      value,
    });
  };

  onResetFilter = (): void => {
    const { onResetFilter } = this.props;

    onResetFilter();
  };
}

const mapStateToProps = (state): ConnectedProps => {
  const { data: { balanceRealTime }, user: { isDownloadRealTimeBalancesEnabled } } = state;

  return {
    balanceRealTime,
    isDownloadRealTimeBalancesEnabled
  };
};

export default connect(mapStateToProps)(addTranslation(OnlineFilters));
